import { render } from "./Notifications.vue?vue&type=template&id=167ad618"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Notifications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "167ad618"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('167ad618', __exports__)) {
    api.reload('167ad618', __exports__)
  }
  
  module.hot.accept("./Notifications.vue?vue&type=template&id=167ad618", () => {
    api.rerender('167ad618', render)
  })

}


export default __exports__